<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div class="kl-field__control text-start">
    @switch (type()) {
      @case ('number') {
        @if (addonButtonLabel()) {
          <div
            class="kl-field__addon-group kl-field__addon-group--number"
            [class.kl-field__addon-group--invalid]="showInvalid()">
            <p-inputNumber
              [inputId]="fieldId()"
              mode="decimal"
              [useGrouping]="useGrouping()"
              [formControlName]="controlName()"
              [placeholder]="placeholder() | translate"
              [min]="min() ?? undefined"
              [max]="max() ?? undefined"
              [minFractionDigits]="minFractionDigits()"
              [maxFractionDigits]="maxFractionDigits()"
              [locale]="translate.currentLang || 'tr'"
              [class.is-invalid]="showInvalid()"
              [fluid]="true"
              (onInput)="onAnyChange()" />
            <p-button
              type="button"
              severity="secondary"
              size="small"
              class="kl-field__addon-p-button"
              [label]="addonButtonLabel() | translate"
              [icon]="addonButtonExpanded() ? 'ph ph-caret-up' : 'ph ph-caret-down'"
              iconPos="right"
              (onClick)="addonButtonClick.emit()" />
          </div>
        } @else {
          <p-inputNumber
            [inputId]="fieldId()"
            mode="decimal"
            [useGrouping]="useGrouping()"
            [formControlName]="controlName()"
            [placeholder]="placeholder() | translate"
            [min]="min() ?? undefined"
            [max]="max() ?? undefined"
            [minFractionDigits]="minFractionDigits()"
            [maxFractionDigits]="maxFractionDigits()"
            [locale]="translate.currentLang || 'tr'"
            [class.is-invalid]="showInvalid()"
            [fluid]="true"
            (onInput)="onAnyChange()" />
        }
      }
      @case ('password') {
        <p-password
          [inputId]="fieldId()"
          [formControlName]="controlName()"
          [placeholder]="placeholder() | translate"
          [toggleMask]="passwordToggleMask()"
          [feedback]="passwordFeedback()"
          [autocomplete]="autocomplete() || 'current-password'"
          [fluid]="true"
          [class]="(showInvalid() ? 'p-invalid ' : '') + 'w-100'" />
      }
      @case ('picker') {
        <div
          class="kl-field__addon-group kl-field__addon-group--picker"
          [class.kl-field__addon-group--invalid]="pickerShowError()">
          <input pInputText type="text" [id]="fieldId()" [value]="pickerDisplayText()" disabled />
          @if (pickerHasDisplayValue() && !pickerReadOnly()) {
            <button type="button" class="kl-field__addon-btn" (click)="onPickerClearClick()">
              <i class="ph ph-x" aria-hidden="true"></i>
            </button>
          }
          @if (!pickerReadOnly()) {
            <button type="button" class="kl-field__addon-btn" (click)="pickerSearch.emit()">
              @if (generateCodeIcon()) {
                <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
              } @else {
                <i class="ph ph-dots-three" aria-hidden="true"></i>
              }
            </button>
          }
        </div>
      }
      @case ('code') {
        <div
          class="kl-field__addon-group kl-field__addon-group--code"
          [class.kl-field__addon-group--invalid]="showInvalid()">
          <input
            pInputText
            type="text"
            [id]="fieldId()"
            [formControlName]="controlName()"
            [attr.maxlength]="maxlength() ?? null" />
          @if (codeShowClear() && !codeReadOnly() && control()?.value) {
            <button type="button" class="kl-field__addon-btn" (click)="onCodeClearClick()">
              <i class="ph ph-x" aria-hidden="true"></i>
            </button>
          }
          @if (!codeReadOnly()) {
            <button type="button" class="kl-field__addon-btn" (click)="codeGenerate.emit()">
              @if (codeGenerating()) {
                <i class="ph ph-spinner kl-input__icon-spin" aria-hidden="true"></i>
              } @else {
                <i [class]="'ph ' + (codeButtonIcon() || 'ph-key')" aria-hidden="true"></i>
              }
            </button>
          }
        </div>
      }
      @default {
        <input
          #plainInput
          pInputText
          [id]="fieldId()"
          [type]="type()"
          [formControlName]="controlName()"
          [placeholder]="placeholder() | translate"
          [autocomplete]="autocomplete()"
          [attr.minlength]="minlength() ?? null"
          [attr.maxlength]="maxlength() ?? null"
          [attr.pattern]="pattern() !== null && pattern() !== undefined ? pattern() : null"
          [invalid]="showInvalid()"
          [fluid]="true"
          (input)="onAnyChange()" />
      }
    }
  </div>

  <div class="kl-field__error text-start">
    @if (showFieldError()) {
      @if (type() === 'picker' && pickerShowError()) {
        <span>{{ pickerErrorKey() | translate }}</span>
      } @else if (controlErrorI18n(); as err) {
        @if ('raw' in err) {
          <span>{{ err.raw }}</span>
        } @else {
          <span>{{ err.key | translate: err.params }}</span>
        }
      }
    }
  </div>
</div>
